
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.info("404:", location.pathname);
    }
  }, [location.pathname]);

  return (
    <div
      style={{ minHeight: '100vh', backgroundColor: '#0B0B0B', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', textAlign: 'center' }}
    >
      <Helmet>
        <title>404 — Página não encontrada | Johnny Vaz</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.7rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1.5rem' }}>
        Erro · 404
      </p>

      <h1
        style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(5rem, 25vw, 14rem)', lineHeight: 0.85, letterSpacing: '-0.02em', color: '#F2EDE3', marginBottom: '0.5rem' }}
      >
        404
      </h1>

      <div style={{ height: '2px', backgroundColor: '#FF4500', width: '64px', margin: '1.5rem auto' }} />

      <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', lineHeight: 1.6, color: '#8C8377', maxWidth: '400px', marginBottom: '2.5rem' }}>
        Essa página não existe ou foi removida. Volte para o início e encontre o que procura.
      </p>

      <Link
        to="/"
        style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.85rem', fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', backgroundColor: '#FF4500', color: '#0B0B0B', padding: '0.9rem 2.5rem', textDecoration: 'none', display: 'inline-block' }}
      >
        Voltar ao início →
      </Link>
    </div>
  );
};

export default NotFound;
